export const participantSource = [{ label: "Mirats Panel", value: "mirats_panel" }, { label: "Own Panel", value: "own_panel" }];
export const researchActivityModeratedSessionTypes = [{ label: "Individual", value: "idi" }, { label: "Group", value: "fgd" }];
export const sessionMethods = [{ label: "Remote Online", value: "remote_online" }, { label: "Remote Phone", value: "remote_phone" }, { label: "In-Person", value: "in_person" }];
export const currencies = [
    { label: 'US Dollar', value: 'USD', symbol: '$' },
    { label: 'Euro', value: 'EUR', symbol: '€' },
    { label: 'Japanese Yen', value: 'JPY', symbol: '¥' },
    { label: 'British Pound Sterling', value: 'GBP', symbol: '£' },
    { label: 'Australian Dollar', value: 'AUD', symbol: 'A$' },
    { label: 'Canadian Dollar', value: 'CAD', symbol: 'C$' },
    { label: 'Swiss Franc', value: 'CHF', symbol: 'CHF' },
    { label: 'Chinese Yuan Renminbi', value: 'CNY', symbol: '¥' },
    { label: 'Swedish Krona', value: 'SEK', symbol: 'kr' },
    { label: 'New Zealand Dollar', value: 'NZD', symbol: 'NZ$' },
    { label: 'Mexican Peso', value: 'MXN', symbol: '$' },
    { label: 'Singapore Dollar', value: 'SGD', symbol: 'S$' },
    { label: 'Hong Kong Dollar', value: 'HKD', symbol: 'HK$' },
    { label: 'Norwegian Krone', value: 'NOK', symbol: 'kr' },
    { label: 'South Korean Won', value: 'KRW', symbol: '₩' },
    { label: 'Turkish Lira', value: 'TRY', symbol: '₺' },
    { label: 'Russian Ruble', value: 'RUB', symbol: '₽' },
    { label: 'Indian Rupee', value: 'INR', symbol: '₹' },
    { label: 'Brazilian Real', value: 'BRL', symbol: 'R$' },
    { label: 'South African Rand', value: 'ZAR', symbol: 'R' },
    { label: 'Philippine Peso', value: 'PHP', symbol: '₱' },
    { label: 'Czech Koruna', value: 'CZK', symbol: 'Kč' },
    { label: 'Indonesian Rupiah', value: 'IDR', symbol: 'Rp' },
    { label: 'Malaysian Ringgit', value: 'MYR', symbol: 'RM' },
    { label: 'Hungarian Forint', value: 'HUF', symbol: 'Ft' },
    { label: 'Polish Zloty', value: 'PLN', symbol: 'zł' },
    { label: 'Israeli New Shekel', value: 'ILS', symbol: '₪' },
    { label: 'Thai Baht', value: 'THB', symbol: '฿' },
    { label: 'United Arab Emirates Dirham', value: 'AED', symbol: 'د.إ' },
    { label: 'Saudi Riyal', value: 'SAR', symbol: '﷼' },
    { label: 'Chilean Peso', value: 'CLP', symbol: '$' },
    { label: 'Colombian Peso', value: 'COP', symbol: '$' },
    { label: 'Egyptian Pound', value: 'EGP', symbol: '£' },
    { label: 'Vietnamese Dong', value: 'VND', symbol: '₫' },
    { label: 'Romanian Leu', value: 'RON', symbol: 'lei' },
    { label: 'Argentine Peso', value: 'ARS', symbol: '$' },
    { label: 'Pakistani Rupee', value: 'PKR', symbol: '₨' },
    { label: 'Bangladeshi Taka', value: 'BDT', symbol: '৳' },
    { label: 'Nigerian Naira', value: 'NGN', symbol: '₦' },
    { label: 'Qatari Riyal', value: 'QAR', symbol: '﷼' },
    { label: 'Kuwaiti Dinar', value: 'KWD', symbol: 'د.ك' },
    { label: 'Bahraini Dinar', value: 'BHD', symbol: 'ب.د' },
    { label: 'Omani Rial', value: 'OMR', symbol: '﷼' },
    { label: 'Sri Lankan Rupee', value: 'LKR', symbol: 'Rs' },
    { label: 'Kenyan Shilling', value: 'KES', symbol: 'KSh' },
    { label: 'Ghanaian Cedi', value: 'GHS', symbol: '₵' },
    { label: 'Tanzanian Shilling', value: 'TZS', symbol: 'TSh' },
    { label: 'Moroccan Dirham', value: 'MAD', symbol: 'د.م.' },
    { label: 'Jordanian Dinar', value: 'JOD', symbol: 'د.ا' },
    { label: 'Peruvian Sol', value: 'PEN', symbol: 'S/.' },
    { label: 'Uruguayan Peso', value: 'UYU', symbol: '$U' },
    { label: 'Ukrainian Hryvnia', value: 'UAH', symbol: '₴' },
    { label: 'Serbian Dinar', value: 'RSD', symbol: 'дин.' },
    { label: 'Tunisian Dinar', value: 'TND', symbol: 'د.ت' },
    { label: 'Icelandic Krona', value: 'ISK', symbol: 'kr' },
    { label: 'Croatian Kuna', value: 'HRK', symbol: 'kn' },
    { label: 'Mauritian Rupee', value: 'MUR', symbol: '₨' },
    { label: 'Nepalese Rupee', value: 'NPR', symbol: '₨' },
    { label: 'Armenian Dram', value: 'AMD', symbol: '֏' },
    { label: 'Georgian Lari', value: 'GEL', symbol: '₾' },
    { label: 'Kazakhstani Tenge', value: 'KZT', symbol: '₸' },
    { label: 'Azerbaijani Manat', value: 'AZN', symbol: '₼' },
    { label: 'Botswana Pula', value: 'BWP', symbol: 'P' },
    { label: 'Zimbabwean Dollar', value: 'ZWL', symbol: 'Z$' },
    { label: 'Paraguayan Guarani', value: 'PYG', symbol: '₲' },
    { label: 'Bolivian Boliviano', value: 'BOB', symbol: 'Bs.' },
    { label: 'Panamanian Balboa', value: 'PAB', symbol: 'B/.' },
    { label: 'Costa Rican Colón', value: 'CRC', symbol: '₡' },
    { label: 'Honduran Lempira', value: 'HNL', symbol: 'L' },
    { label: 'Guatemalan Quetzal', value: 'GTQ', symbol: 'Q' },
    { label: 'Dominican Peso', value: 'DOP', symbol: 'RD$' },
    { label: 'Trinidad and Tobago Dollar', value: 'TTD', symbol: 'TT$' },
    { label: 'Jamaican Dollar', value: 'JMD', symbol: 'J$' },
    { label: 'Namibian Dollar', value: 'NAD', symbol: 'N$' },
    { label: 'Zambian Kwacha', value: 'ZMW', symbol: 'ZK' },
    { label: 'Malawi Kwacha', value: 'MWK', symbol: 'MK' },
    { label: 'Mozambican Metical', value: 'MZN', symbol: 'MT' },
    { label: 'Rwandan Franc', value: 'RWF', symbol: 'FRw' },
    { label: 'Burundian Franc', value: 'BIF', symbol: 'FBu' },
    { label: 'Congolese Franc', value: 'CDF', symbol: 'FC' },
    { label: 'Algerian Dinar', value: 'DZD', symbol: 'دج' },
    { label: 'Ethiopian Birr', value: 'ETB', symbol: 'Br' },
    { label: 'Cambodian Riel', value: 'KHR', symbol: '៛' },
    { label: 'Laotian Kip', value: 'LAK', symbol: '₭' },
    { label: 'Mongolian Tugrik', value: 'MNT', symbol: '₮' },
    { label: 'North Korean Won', value: 'KPW', symbol: '₩' },
    { label: 'Afghan Afghani', value: 'AFN', symbol: '؋' },
    { label: 'Syrian Pound', value: 'SYP', symbol: '£' },
    { label: 'Lebanese Pound', value: 'LBP', symbol: 'ل.ل' },
    { label: 'Iranian Rial', value: 'IRR', symbol: '﷼' },
    { label: 'Iraqi Dinar', value: 'IQD', symbol: 'ع.د' },
    { label: 'Libyan Dinar', value: 'LYD', symbol: 'ل.د' },
    { label: 'Sudanese Pound', value: 'SDG', symbol: 'ج.س' },
    { label: 'Somali Shilling', value: 'SOS', symbol: 'Sh' },
    { label: 'Seychellois Rupee', value: 'SCR', symbol: '₨' },
    { label: 'Bhutanese Ngultrum', value: 'BTN', symbol: 'Nu.' },
];
export const statusesOption = [
    {
        label: "All",
        value: "",
    },
    {
        label: "Draft",
        value: "draft",
    },
    {
        label: "Paused",
        value: "paused",
    },
    {
        label: "In Review",
        value: "submitted_for_review",
    },
    {
        label: "Changes Requested",
        value: "changes_requested",
    },
    {
        label: "Live",
        value: "live",
    },
    {
        label: "Completed",
        value: "completed",
    },
    {
        label: "Closed",
        value: "closed",
    },
    {
        label: "Canceled",
        value: "canceled",
    }
]
export const EDITABLE_STATUSES = ["draft", "changes_requested", "paused"];

export const datasetParticipantStatusColorMap = {
    1: 'default', // Draft
    2: 'secondary', // Pending
    3: 'success', // Invited
    4: 'primary', // Started
    5: 'success', // Completed
    6: 'warning', // Dropped
    7: 'error', // Disqualified
};
export const getStatusChipColor = (status) => {
    return datasetParticipantStatusColorMap[status] ?? 'default';
};
